import { useEffect } from 'react';
import Page from 'shared/types/Page'
import MenuIcons from 'components/AppRouter/MenuIcons'
import hasAnyRole from 'shared/utils/hasAnyRole'

interface useInitProps {
  curLink: string
  curIcon?: any
  curIconActive?: any
  isActive?: boolean
  label: string
  pages: Page[] | undefined
  setActiveClass: Function
  setIcon: Function
  setSubMenuPages: Function
  setShowSubmenu: Function
  curPage: Page | null
}

const useInit = (props: useInitProps) => {
  useEffect(() => {
    if (props.curPage) {
      let isActive = false

      if (props.pages) {
        let subPages: Page[] = []
        props.pages.map((page) => {
          if (
            page.dropdownName === props.label &&
            (page.roles === undefined || hasAnyRole(page.roles))
          ) {
            subPages.push(page)
          }
        })
        props.setSubMenuPages(subPages)
      }

      let newActiveClass = ''

      // determine if parent
      if (props.curPage?.dropdownName !== undefined) {
        if (props.label === props.curPage.dropdownName) {
          isActive = true
        }
      }

      if (props.curPage?.dropdownName == props.label) newActiveClass = ' active parent'

      props.setShowSubmenu(isActive)
      if (props.curIcon) {
        const icon = isActive
          ? MenuIcons[props.curIcon]['active']
          : MenuIcons[props.curIcon]['inactive']
        props.setIcon(<span className='icon-cont'>{icon}</span>)
      }
      props.setActiveClass(newActiveClass)
    }
  }, ['', props.curPage])
}

export default useInit